'use strict';

// Some standard behaviors for all outstream ads -- these will be passed
// through into our player code for setup.
const config = {
    // This value should match the duration of the animation defined in
    // the variable $m_ad_outstream_transition in the file
    // _module-ad-outstream.scss
    containerAnimationDuration: 700,
    // The location of our dummy "content"; this should be a small,
    // fast-loading file that ends quickly, as it will play after we've
    // displayed our outstream ad.
    fileUrl: 'https://adcontent.saymedia.com/black-1s.mp4',
    // This should be a double value between 0 and 1, representing the
    // percentage of the outstream iframe which must be in the viewport in
    // order to be displayed.
    threshold: 0.5,
    // videos which duration is =< that this value will block the outstream
    // player
    minAllowedDuration: 1,
    roadblockSizes: ['7x7', '8x8'],
};

// And the URLs for the actual JWPlayer script, in cloud-hosted and self-hosted
// forms.
const SCRIPT_URL = 'https://content.jwplatform.com/libraries/l0Tc9yhq.js';
const SELFHOSTED_SCRIPT_URL = 'https://adcontent.saymedia.com/jwplayer-outstream-selfhosted.js';

module.exports = {
    config: config,
    scriptUrl: SCRIPT_URL,
    selfhostedScriptUrl: SELFHOSTED_SCRIPT_URL,
};
